export const Z_MODAL = 1005;
export const Z_GUEST_SPEAKER_LAYER = 1004;
export const Z_NAV_CONTROLS_MOBILE = 1003;
export const Z_LS_ACTIVE_USER_CTA = 1002; // Tap to watch overlay
export const Z_HEADER = 1001;
export const Z_FOOTER = 1000;
export const Z_GATE = 998;
export const Z_INTERACTIONS = 101;
export const Z_IMA_LAYER_WRAPPER = 1;
export const Z_ERROR_CONTENT_WRAPPER = 1;
export const Z_DROPDOWN_CONTENT = 1;
export const Z_PDP_PRODUCT_MOMENT = 1;
export const Z_PRODUCT_DETAIL_FOOTER = 1;
